<template>
    <el-card class="card-container">
      <template #header>
        <div class="card-header">
          <span>Pre-Order MarsWear Smart Knee Sleeves</span>
        </div>
      </template>
      <el-alert class="mb-2" v-if="showPaymentFailedAlert" title="Incomplete payment. Please try again." type="error" show-icon :closable="false" />
      <el-row :gutter="20" class="mb-3 description-container">
        <el-col :lg="12" :sm="24">
            <img class="image" src="https://texavie.com/wp-content/uploads/2024/02/MWKS-1-24-1497x1536.jpg">
        </el-col>
        <el-col :lg="12" :sm="24">
  <div class="package-includes">
    <p><strong>INCLUDED IN THE PACKAGE:</strong></p>
    <ul>
      <li class="text-color">TWO MARSWEAR SMART KNEE SLEEVES</li>
      <li class="text-color">ONE DURABLE CHARGING CABLE</li>
      <li class="text-color">ONE CHARGING STATION</li>
      <li class="text-color">ONE PROTECTIVE CARRYING CASE</li>
    </ul>
  </div>

  <div class="compatibility">
    <p><strong>COMPATIBILITY:</strong></p>
    <p>WORKS WITH IOS, IPADOS, AND ANDROID DEVICES.</p>
  </div>

  <div class="sizes-available">
    <p><strong>SIZES AVAILABLE:</strong></p>
    <p>SMALL (S), MEDIUM (M), LARGE (L), AND EXTRA LARGE (XL). SIZE SELECTION WILL BE AVAILABLE BEFORE SHIPPING.</p>
  </div>
</el-col>

      </el-row>
      <el-form
        :model="form"
        :rules="rules"
        ref="preorderForm"
        label-position="top"
        class="preorder-form"
        v-loading="isSubmittingForm"
        element-loading-text="Redirecting to checkout..."
        element-loading-background="rgba(255, 255, 255);
"
      >
        <!-- Quantity -->
        <el-form-item label="Quantity" prop="quantity">
          <el-input-number
            @update:model-value="value => form.quantity = value"
            :model-value="form.quantity"
            :min="minQuantity"
            label="Quantity"
            controls-position="right"
            class="left-align"
          ></el-input-number>
        </el-form-item>

        <span class="small-text">Ordering on Behalf of an Organization?</span>
        <el-form-item class="mb-0">
          <el-checkbox
            @update:model-value="updateOrganizationStatus"
            :model-value="form.isOrganizationOrder"
            ><span class="accent-text"
              >Yes, this is an organization order.</span
            ></el-checkbox
          >
        </el-form-item>
        <span class="small-text"
            >Bulk Order Discount Available! Orders of more than 10 items placed on
            behalf of an organization are eligible for a discount. Please check
            the box if this applies to you.
      </span>
        <el-form-item
          v-if="form.isOrganizationOrder"
          label="Organization Name"
          prop="organizationName"
          class="mt-3"
        >
          <el-input
            @update:model-value="value => form.organizationName = value"
            :model-value="form.organizationName"
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="form.isOrganizationOrder"
          label="Please describe how you plan to use our product within your organization."
          prop="planToUseProduct"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            @update:model-value="value => form.planToUseProduct = value"
            :model-value="form.planToUseProduct"
          ></el-input>
        </el-form-item>

        <!-- Personal Information -->
        <el-row :gutter="20"  class="mt-3">
          <el-col :lg="12" :sm="24">
            <el-form-item label="First Name" prop="firstName">
              <el-input
                @update:model-value="value => form.firstName = value"
                :model-value="form.firstName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="24">
            <el-form-item label="Last Name" prop="lastName">
              <el-input
                @update:model-value="value => form.lastName = value"
                :model-value="form.lastName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :lg="12" :sm="24">
            <el-form-item label="Email Addres" prop="email">
              <el-input disabled
                @update:model-value="value => form.email = value"
                :model-value="form.email"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="24">
            <el-form-item label="Phone Number" prop="phone">
              <el-input
                @update:model-value="value => form.phone = value"
                :model-value="form.phone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- Add other fields similarly -->
        <el-form-item label="Street Address" prop="streetAddress">
          <el-input
            @update:model-value="value => form.streetAddress = value"
            :model-value="form.streetAddress"
          ></el-input>
        </el-form-item>

        <el-form-item label="Apartment, suite, etc" prop="address2">
          <el-input
            @update:model-value="value => form.address2 = value"
            :model-value="form.address2"
          ></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :lg="12" :sm="24">
            <el-form-item label="City" prop="city">
              <el-input
                @update:model-value="value => form.city = value"
                :model-value="form.city"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="24">
            <el-form-item label="State" prop="state">
              <el-input
                @update:model-value="value => form.state = value"
                :model-value="form.state"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :lg="12" :sm="24">
            <el-form-item label="Postal Code" prop="postalCode">
              <el-input
                @update:model-value="value => form.postalCode = value"
                :model-value="form.postalCode"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="24">
            <el-form-item label="Country" prop="country">
              <el-input
                @update:model-value="value => form.country = value"
                :model-value="form.country"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Use Application" prop="useApplication">
          <el-input
            @update:model-value="value => form.useApplication = value"
            :model-value="form.useApplication"
          ></el-input>
        </el-form-item>

        <el-form-item label="Request detail notes" prop="requestDetails">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            @update:model-value="value => form.requestDetails = value"
            :model-value="form.requestDetails"
          ></el-input>
        </el-form-item>

        <el-form-item label="How did you hear about us?">
          <el-checkbox-group  @update:model-value="value => form.howDidYouHearAboutUs = value"
            :model-value="form.howDidYouHearAboutUs">
            <el-checkbox value="Social media">
              Social media
            </el-checkbox>
            <el-checkbox value="Referral">
              Referral
            </el-checkbox>
            <el-checkbox value="Search engine">
              Search engine
            </el-checkbox>
            <el-checkbox value="Other">
              Other
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <!-- Acceptance -->
        <el-form-item
          class="terms-item"
          prop="terms"
          :class="{ 'error-border': termsNotChecked }"
        >
          <el-checkbox
            class="break-text"
            @update:model-value="value => form.terms = value"
            :model-value="form.terms"
          >
            I accept the
            <a
              href="https://texavie.com/terms-and-conditions/"
              target="_blank"
              class="terms-link"
              >terms and conditions</a
            >. The pre-order is a deposit for the product to be delivered in the
            next six months and the final price will be determined at a later
            date.
          </el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-checkbox
            class="break-text"
            @update:model-value="value => form.subscribe = value"
            :model-value="form.subscribe"
            >Yes, I want to subscribe to promotional newsletters and updates from
            Texavie for this and other related products.</el-checkbox
          >
        </el-form-item>

        <div class="price-summary">
          <div class="price-row">
            <span class="label">Subtotal:</span>
            <span class="value">$ {{ subtotal }}</span>
          </div>
          <div class="price-row">
            <span class="label">GST (5%):</span>
            <span class="value">$ {{ gst  }}</span>
          </div>
          <div class="price-row">
            <span class="label">PST (7%):</span>
            <span class="value">$ {{ pst  }}</span>
          </div>
          <div class="price-row">
            <span class="label">Total:</span>
            <span class="value">$ {{ total }}</span>
          </div>
        </div>

        <!-- Submit Button -->
        <el-form-item>
          <button class="preorder-btn" @click.prevent="submitForm">Submit</button>
        </el-form-item>
      </el-form>

    </el-card>
  </template>

<script>
import { xray } from '../../config/pluginInit'
import { onMounted, ref, watch, computed } from 'vue'
import { httpsCallable } from 'firebase/functions'
import firebaseService from '../../../firebase'
import { useRoute } from 'vue-router'

export default {
  mounted () {
    xray.index()
  },
  name: 'KneeSleevePreorderForm',
  setup (props, context) {
    const preorderForm = ref(null)
    const minQuantity = ref(1)
    const unitPrice = 299
    const organizationPrice = 279
    const termsNotChecked = ref(false)
    const createDevicePreorderCheckoutSession = httpsCallable(firebaseService.functions, 'createDevicePreorderCheckoutSession')
    const isSubmittingForm = ref(false)
    const showPaymentFailedAlert = ref(false)
    const route = useRoute()

    onMounted(() => {
      if (route.name === 'patient.PreorderCancel') {
        showPaymentFailedAlert.value = true
      }
    })

    watch(() => route.name, (newValue) => {
      if (route.name === 'patient.PreorderCancel') {
        showPaymentFailedAlert.value = true
      } else {
        showPaymentFailedAlert.value = false
      }
    })

    const form = ref({
      quantity: 1,
      isOrganizationOrder: false,
      firstName: '',
      organizationName: '',
      planToUseProduct: '',
      lastName: '',
      email: firebaseService.firebaseAuth.currentUser.email,
      phone: '',
      streetAddress: '',
      address2: '',
      city: '',
      state: '',
      postalCode: '',
      country: '',
      useApplication: '',
      requestDetails: '',
      howDidYouHearAboutUs: [],
      terms: false,
      subscribe: false
      // Add other fields as needed
    })

    const subtotal = computed(() => {
      return form.value.isOrganizationOrder
        ? form.value.quantity * organizationPrice
        : form.value.quantity * unitPrice
    })
    const gst = computed(() => (subtotal.value * 0.05).toFixed(2))
    const pst = computed(() => (subtotal.value * 0.07).toFixed(2))
    const total = computed(() => (subtotal.value * 1.12).toFixed(2))

    const rules = ref({
      quantity: [{ required: true, message: 'Please input the quantity', trigger: 'blur' }],
      firstName: [{ required: true, message: 'Please input your first name', trigger: 'blur' }],
      lastName: [{ required: true, message: 'Please input your last name', trigger: 'blur' }],
      phone: [{ required: true, message: 'Please input your phone number', trigger: 'blur' }],
      email: [{ required: true }],
      terms: [
        {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (value) {
              termsNotChecked.value = false
              callback()
            } else {
              termsNotChecked.value = true
              callback(new Error())
            }
          }
        }
      ],
      streetAddress: [{ required: true, message: 'Please input your street address', trigger: 'blur' }],
      city: [{ required: true, message: 'Please input your city', trigger: 'blur' }],
      state: [{ required: true, message: 'Please input your state', trigger: 'blur' }],
      postalCode: [{ required: true, message: 'Please input your postal code', trigger: 'blur' }],
      country: [{ required: true, message: 'Please input your country', trigger: 'blur' }]
      // Define other field rules as needed
    })

    const submitForm = async () => {
      preorderForm.value.validate(async (valid) => {
        if (valid) {
          const lineItems = [
            {
              price: form.value.isOrganizationOrder ? 'price_1PC5bwA844XXZODASyxJdpWd' : 'price_1PC5bwA844XXZODAsC3w9sY7',
              quantity: form.value.quantity,
              tax_rates: ['txr_1N8vtOA844XXZODAqyNn5hon', 'txr_1N8vsIA844XXZODAJyVpKPaa']

            }]
          const metadata = form.value
          metadata.productType = 'Preorder'
          metadata.subtotal = `$ ${subtotal.value}`

          metadata.gst = `$ ${gst.value}`
          metadata.pst = `$ ${pst.value}`
          metadata.total = `$ ${total.value}`
          if (!form.value.isOrganizationOrder) {
            delete metadata.organizationName
            delete metadata.planToUseProduct
          }
          if (metadata.howDidYouHearAboutUs.length !== 0) {
            metadata.howDidYouHearAboutUs = metadata.howDidYouHearAboutUs.join(', ')
          }

          try {
            isSubmittingForm.value = true
            const response = await createDevicePreorderCheckoutSession({ lineItems: lineItems, uid: firebaseService.firebaseAuth.currentUser.uid, metadata })
            console.log(response)
            window.location.href = response.data.url
            isSubmittingForm.value = false
          } catch (error) {
            console.log(error)
          }
        } else {
          return false
        }
      })
    }

    const updateOrganizationStatus = (value) => {
      form.value.isOrganizationOrder = value
      if (value) {
        form.value.quantity = Math.max(10, form.value.quantity)
        minQuantity.value = 10
      } else {
        minQuantity.value = 1
      }
    }

    // Watch for blurs in isOrganizationOrder to update validation rules accordingly
    watch(() => form.value.isOrganizationOrder, (newValue) => {
      rules.value.organizationName = newValue ? [{ required: true, message: 'Please input the organization name', trigger: 'blur' }] : []
      rules.value.planToUseProduct = newValue ? [{ required: true, message: 'Please describe how you plan to use our product within your organization', trigger: 'blur' }] : []
    })
    return {
      form,
      rules,
      submitForm,
      preorderForm,
      updateOrganizationStatus,
      minQuantity,
      subtotal,
      gst,
      pst,
      total,
      termsNotChecked,
      showPaymentFailedAlert,
      isSubmittingForm
    }
  }
}
</script>

  <style scoped>
  .card-container {
    margin: 0 20px 20px 20px;
  }

  .card-header {
    background: transparent;
    border-bottom: none;
  }

  .card-header span {
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color) !important;
  }

  .image {
    height: auto;
    width: 100%;
  }

  .el-input-number {
    width: 100%;
  }

  .small-text {
    font-size: 12px;
    color: var(--muted-text-color);
  }

  .accent-text {
    color: var(--accent-color);
  }

  .preorder-btn {
    background-color: var(--accent-color);
    width: 200px;
    color: white !important;
    margin-left: auto;
  }

  .price-summary {
    /* width: 100%; */
    padding: 10px;
  }

  .price-row {
    display: flex;
    justify-content: end;
    margin-bottom: 25px;
  }

  .price-row .label {
    font-weight: normal;
    margin-right: 20px;
  }

  .price-row .value {
    font-weight: bold;
  }

  .price-row.total .label,
  .price-row.total .value {
    font-size: 1.2em;
  }

  .description-container {
    align-items: center;
  }

  .terms-item {
    margin-bottom: 15px !important;
  }

  @media (max-width: 680px) {
    /* Adjust '600px' based on when you notice the overlap */
    .terms-item {
      margin-bottom: 50px !important; /* Increase this value as needed */
    }
  }


  /* You might want to add additional breakpoints for different screen sizes */
  @media (max-width: 514px) {
    .terms-item {
      margin-bottom: 70px !important;
    }
  }
  </style>

  <style>
  .left-align.el-input-number .el-input__inner {
    text-align: left !important;
  }

  .el-form-item__error {
    padding: 5px 0 !important;
  }

  .el-form-item {
    margin-bottom: 30px !important;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: var(--text-color) !important;
    transition: background-color 5000s ease-in-out 0s !important;
    box-shadow: inset 0 0 20px 20px transparent !important;
  }

  .break-text .el-checkbox__label {
    white-space: normal;
    line-height: 1.5; /* Adjust line-height for better readability between lines */
  }


  .error-border .el-checkbox__input.is-checked .el-checkbox__inner,
  .error-border .el-checkbox__input .el-checkbox__inner {
    border-color: var(--error-color) !important;
  }

  .error-border .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: var(--error-color) !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--muted-text-color) !important;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 15px;
    color: var(--accent-color) !important;
  }

  @media (max-width: 1555px) {

    .break-text .el-checkbox__input {
    vertical-align: top !important;
    }
    }
  </style>
